import React from 'react'
import PropTypes from 'prop-types'

import * as styles from './styles'

// Source: https://github.com/ranyefet/react-file-input

const FileInput = props => (
  <div className={props.className} style={{ ...styles.container, ...props.style }}>
    <input accept={props.accept} disabled={props.disabled} name={props.name} onChange={props.onChange} style={styles.input} type="file" />

    {props.children}
  </div>
)

FileInput.propTypes = {
  accept: PropTypes.string,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  name: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  style: PropTypes.object,
}

FileInput.defaultProps = {
  accept: '',
  className: '',
  disabled: false,
  name: 'file',
  style: {},
}

export default FileInput
